import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { readRouteParam } from '../../../_utils/route-param.utils';
import { TranslateModule } from '@ngx-translate/core';
import IRole from '../../../_interfaces/IRole';
import { AdminEntityLoaderService } from '../../../_services/admin/admin-entity-loader.service';
import { AdminFormLayoutComponent } from '../../../components/admin-ui/admin-form-layout/admin-form-layout.component';
import { AdminStatePanelComponent } from '../../../components/admin-ui/admin-state-panel/admin-state-panel.component';
import { FormRoleWidgetsComponent } from '../../../components/forms/form-role-widgets/form-role-widgets.component';

@Component({
  selector: 'app-admin-role-widgets',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    AdminFormLayoutComponent,
    AdminStatePanelComponent,
    FormRoleWidgetsComponent,
  ],
  templateUrl: './admin-role-widgets.component.html',
  styleUrl: './admin-role-widgets.component.scss',
})
export class AdminRoleWidgetsComponent implements OnInit {
  public customersId = 0;
  public rolesId = 0;
  public role: IRole | null = null;
  public loading = true;
  public hasError = false;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly loader: AdminEntityLoaderService,
  ) {}

  ngOnInit(): void {
    this.customersId = readRouteParam(this.route, 'customers_id');
    this.rolesId = readRouteParam(this.route, 'roles_id');
    this.load(true);
  }

  load(fromResolver = false): void {
    this.loading = true;
    this.hasError = false;

    if (fromResolver) {
      const role = (this.route.parent?.snapshot.data['role'] || null) as
        | IRole
        | null;
      if (role) {
        this.role = role;
        this.loading = false;
        return;
      }
    }

    this.loader.loadRole(this.customersId, this.rolesId).subscribe({
      next: (role) => {
        this.role = role;
        this.hasError = !role;
        this.loading = false;
      },
      error: () => {
        this.hasError = true;
        this.loading = false;
      },
    });
  }
}
